import React, { useRef, useState } from "react";
import styles from "./NumberDisplay.module.css";

// US-style grouping only while the number is short and local.
const formatDisplay = (num) => {
  if (!num) return "";
  // + / * / # ko grouping kha jaati hai — aise number jaise type hua waise hi dikhao.
  if (/[+*#]/.test(num)) return num;
  const digits = num.replace(/\D/g, "");
  if (digits.length > 10) return num;
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};

const NumberDisplay = ({
  number,
  onChange,
  onDelete,
  onLongDelete,
  callerId,
  callerIds = [],
  onCallerIdChange,
}) => {
  const longPressRef = useRef(null);
  const [pickerOpen, setPickerOpen] = useState(false);

  // An agent can own several numbers — only offer a choice when there is one.
  const hasChoice = callerIds.length > 1 && typeof onCallerIdChange === "function";

  const startPress = () => {
    longPressRef.current = setTimeout(() => {
      onLongDelete?.();
      longPressRef.current = "fired";
    }, 600);
  };

  const endPress = () => {
    if (longPressRef.current === "fired") {
      longPressRef.current = null;
      return;
    }
    clearTimeout(longPressRef.current);
    longPressRef.current = null;
    onDelete?.();
  };

  const len = number.length;
  const sizeClass = len > 15 ? styles.small : len > 11 ? styles.medium : styles.large;

  return (
    <div className={styles.wrap}>
      {callerId ? (
        <div className={styles.callerIdWrap}>
          <button
            type="button"
            className={styles.callerId}
            onClick={hasChoice ? () => setPickerOpen((o) => !o) : undefined}
            disabled={!hasChoice}
          >
            <span className={styles.callerIdDot} />
            Calling from {callerId}
            {hasChoice ? <span className={styles.caret}>▾</span> : null}
          </button>

          {pickerOpen && hasChoice ? (
            <ul className={styles.picker}>
              {callerIds.map((num) => (
                <li key={num}>
                  <button
                    type="button"
                    className={`${styles.pickerItem} ${num === callerId ? styles.pickerActive : ""}`}
                    onClick={() => {
                      onCallerIdChange(num);
                      setPickerOpen(false);
                    }}
                  >
                    {num}
                    {num === callerId ? <span className={styles.tick}>✓</span> : null}
                  </button>
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      ) : null}

      <div className={styles.row}>
        <input
          className={`${styles.input} ${sizeClass}`}
          value={formatDisplay(number)}
          onChange={(e) => onChange?.(e.target.value.replace(/[^\d+*#]/g, ""))}
          placeholder="Enter number"
          inputMode="tel"
          aria-label="Phone number"
        />

        {number.length > 0 && (
          <button
            type="button"
            className={styles.deleteBtn}
            aria-label="Delete"
            onMouseDown={startPress}
            onTouchStart={startPress}
            onMouseUp={endPress}
            onTouchEnd={(e) => {
              e.preventDefault();
              endPress();
            }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M22 3H7C6.27 3 5.77 3.35 5.41 3.83L0 12L5.41 20.18C5.77 20.64 6.27 21 7 21H22C23.1 21 24 20.1 24 19V5C24 3.9 23.1 3 22 3Z"
                fill="#c9c3d8"
              />
              <path
                d="M18 8.41L16.59 7L13 10.59L9.41 7L8 8.41L11.59 12L8 15.59L9.41 17L13 13.41L16.59 17L18 15.59L14.41 12L18 8.41Z"
                fill="#fff"
              />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default NumberDisplay;
